module.exports = __webpack_public_path__ + "static/media/group-1.33438fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group-1.png
// module id = 1270
// module chunks = 1